import IS_MOBILE from '/utils/is-mobile'

export const selector = '.projects'

export function hydrate (element) {
  const details = element.querySelectorAll('details')

  // Open whichever project matches the url anchor (falls back to
  // whatever was rendered open server-side, i.e. the first project)
  openHash(element)

  // Keep the url anchor in sync with whatever the visitor opens by hand
  for (const detail of details) detail.addEventListener('toggle', handleDetailToggle)

  if (IS_MOBILE) {
    return {
      destroy: () => {
        for (const detail of details) detail.removeEventListener('toggle', handleDetailToggle)
      }
    }
  }

  let nextFrame
  const gallery = element.querySelector('.projects__gallery')
  const images = element.querySelectorAll('.projects__item .gallery li')

  // Modify DOM on desktop (OMG…)
  for (const image of images) gallery.appendChild(image)

  // Bindings
  for (const detail of details) detail.addEventListener('click', handleDetailClick)
  gallery.addEventListener('wheel', handleGalleryWheel)

  return {
    destroy: () => {
      gallery.removeEventListener('wheel', handleGalleryWheel)
      for (const detail of details) detail.removeEventListener('click', handleDetailClick)
      for (const detail of details) detail.removeEventListener('toggle', handleDetailToggle)
    }
  }

  function open (targetDetail, { updateHash = true, scroll = false } = {}) {
    if (!targetDetail) return

    // Radio behavior
    for (const el of details) {
      el.open = targetDetail === el
    }

    if (updateHash) setHash(targetDetail.id)
    if (scroll) targetDetail.scrollIntoView({ block: 'start' })
  }

  function handleDetailClick (e) {
    const current = e.target.closest('details')

    e.preventDefault()
    open(current)

    // Scroll to image
    const image = gallery.querySelector('#' + current.id)
    gallery.scrollTo({
      left: image.offsetLeft,
      behavior: 'smooth',
    })
  }

  function handleGalleryWheel (e) {
    cancelAnimationFrame(nextFrame)
    nextFrame = requestAnimationFrame(() => {
      // Find currently viewed image
      let current
      for (let index = images.length - 1; index >= 0; index--) {
        current = images[index]
        if (!current.id) continue // Only use images with a valid id (first image of each gallery)
        if (current.offsetLeft < gallery.clientWidth + gallery.scrollLeft) break
      }

      // Open matching <details>
      open(element.querySelector('details#' + current.id), { scroll: false })
    })
  }

  function handleDetailToggle (e) {
    if (e.target.open) setHash(e.target.id)
  }
}

// Open the project matching a given url hash (falls back to the current
// window location when none is passed). Barba's prefetch can hydrate a
// page's container ahead of time, while its target hash is still unknown
// (the visitor hasn't clicked yet) — so this is exported and called again
// explicitly, with the hash Barba actually navigated to, once it's known.
// Doesn't scroll: callers decide if/when that should happen.
export function openHash (element, hash = window.location.hash) {
  const targetId = hash.slice(1)
  if (!targetId) return null

  const target = element.querySelector('details#' + CSS.escape(targetId))
  if (!target) return null
  if (target.open) return target

  for (const el of element.querySelectorAll('details')) {
    el.open = target === el
  }

  return target
}

// Reflect a project's id in the url without triggering navigation/scroll
function setHash (id) {
  if (!id || window.location.hash.slice(1) === id) return
  window.history.replaceState(null, '', '#' + id)
}
